import Category from '@/models/Category';
import Tag from '@/models/Tag';
import * as Yup from 'yup';

export interface FormObject {
    [key: string]: string | Category[] | Tag[] | undefined;
    name: string;
    description?: string;
    locale: string;
    categories: Category[];
    tags: Tag[];
}

export interface LanguageOptions {
    description: string;
    value: string;
}

export interface MyCreationsConstantsType {
    name: string;
    description: string;
    locale: string;
    categories: string;
    tags: string;
}

export const myCreationsConstants: MyCreationsConstantsType = {
    name: 'name',
    description: 'description',
    locale: 'locale',
    categories: 'categories',
    tags: 'tags',
};

export const initialFormObject: FormObject = {
    name: '',
    description: '',
    locale: '',
    categories: [] as Category[],
    tags: [] as Tag[],
};

export const formSchema = Yup.object().shape<FormObject>({
    name: Yup.string()
        .trim()
        .required()
        .min(1),
    description: Yup.string().notRequired(),
    locale: Yup.string()
        .required()
        .min(1),
    categories: Yup.array<Category>().min(1),
    tags: Yup.array<Tag>().min(1),
});
